// usePageTitle.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../redux-stores/slices/layoutSlice';

const usePageTitle = (title: string) => {
  const dispatch = useDispatch();

  // Set the page title when the component mounts
  useEffect(() => {
    // Dispatch the action to set the title
    dispatch(setPageTitle(title));

    // Optionally, reset the title when the component unmounts
    return () => {
      dispatch(setPageTitle(''));
    };
  }, [dispatch, title]); // Dependency on title so it resets when title changes
};

export default usePageTitle;